@if (entry.children) {
  @if (hasPermission(entry) | async) {
    <a
      mad-sidebar-item
      [routerLink]="entry.route"
      routerLinkActive="active-sidebar-item"
      (click)="toggleChildren(entry)"
      #isRouteActive="routerLinkActive"
    >
      <div class="content-display-flex">
        <div class="display-inherit-gap">
          <mat-icon [ngStyle]="navEntryService.getMarginLeft(sublevel, 8)">{{ entry.matIcon }}</mat-icon>
          <span>{{ entry.i18n | translate }}</span>
        </div>
        <span class="align-icons">
          @if (isOpen(entry, isRouteActive.isActive)) {
            <mat-icon class="arrow-icons">keyboard_arrow_down</mat-icon>
          } @else {
            <mat-icon class="arrow-icons">keyboard_arrow_right</mat-icon>
          }
        </span>
      </div>
    </a>
  }
  <div [hidden]="!isOpen(entry)">
    @for (subEntry of entry.children; track subEntry) {
      @if (hasPermission(subEntry) | async) {
        <nav-entry [entry]="subEntry" [sublevel]="sublevel + 1"></nav-entry>
      }
    }
  </div>
} @else {
  @if (hasPermission(entry) | async) {
    <nav-child [entry]="entry" [sublevel]="sublevel"></nav-child>
  }
}
